/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestDeleteBaseRequest
 */
export interface RequestDeleteBaseRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteBaseRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteBaseRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteBaseRequest
     */
    updatedUserId?: number;
}

/**
 * Check if a given object implements the RequestDeleteBaseRequest interface.
 */
export function instanceOfRequestDeleteBaseRequest(value: object): value is RequestDeleteBaseRequest {
    return true;
}

export function RequestDeleteBaseRequestFromJSON(json: any): RequestDeleteBaseRequest {
    return RequestDeleteBaseRequestFromJSONTyped(json, false);
}

export function RequestDeleteBaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteBaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedUserId': json['updated_user_id'] == null ? undefined : json['updated_user_id'],
    };
}

export function RequestDeleteBaseRequestToJSON(json: any): RequestDeleteBaseRequest {
    return RequestDeleteBaseRequestToJSONTyped(json, false);
}

export function RequestDeleteBaseRequestToJSONTyped(value?: RequestDeleteBaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'updated_user_id': value['updatedUserId'],
    };
}

